import { defineComponent as t, createBlock as c, openBlock as o, unref as r, mergeProps as d, withCtx as i, createElementVNode as l } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceShieldOutlined",
  __name: "IconReassuranceShieldOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (u, e) => (o(), c(r(p), d(n, { "view-box": "0 0 48 48" }), {
      default: i(() => [...e[0] || (e[0] = [
        l("path", { d: "M27.227 23.1c.395.148.984-.405 1.287-1.235.313-.829.225-1.61-.17-1.768-.393-.158-.972.398-1.285 1.226-.313.828-.228 1.629.168 1.777m3.432-.425c-.191.86-.008 1.657.41 1.73.454.1.918-.524 1.11-1.394.193-.869.018-1.655-.41-1.74-.426-.085-.92.544-1.11 1.404m-7.555-.701a.329.329 0 0 0-.244.003l.029.005a.338.338 0 0 0-.183.311 6.864 6.864 0 0 0 .912 2.566 7.533 7.533 0 0 0 .784 1.12 8.093 8.093 0 0 0 3.327 2.285 8.245 8.245 0 0 0 2.628.463.32.32 0 1 0 .063-.637 9.232 9.232 0 0 1-4.386-2.01 9.126 9.126 0 0 1-1.582-1.771 13.353 13.353 0 0 1-1.169-2.17.33.33 0 0 0-.179-.165" }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M26.681 9.064a.5.5 0 0 0-.437-.079 227.98 227.98 0 0 0-1.352.4c-2.249.668-4.045 1.203-5.8 1.29-2.043.102-4.043-.406-6.584-2.155a.5.5 0 0 0-.776.325l.492.087-.492-.087-2.557 14.498c-1.04 5.902 1.857 10.529 4.937 13.638a27.692 27.692 0 0 0 6.274 4.701 10.17 10.17 0 0 0 .115.06l.03.016.01.004.002.002.224-.447-.223.447a.5.5 0 0 0 .28.05l-.057-.497.057.496h.004l.01-.001.034-.004a17.726 17.726 0 0 0 .607-.091 27.693 27.693 0 0 0 7.025-2.198c3.958-1.868 8.262-5.226 9.303-11.128l2.556-14.497-.492-.087.492.087a.501.501 0 0 0-.615-.572c-3.028.768-5.101.558-6.986-.236-1.635-.69-3.14-1.819-5.022-3.231a233.129 233.129 0 0 0-1.059-.791M12.584 9.769c2.408 1.519 4.448 2.01 6.557 1.905 1.887-.094 3.82-.67 6.067-1.34l1.077-.319.834.625c1.877 1.41 3.497 2.626 5.255 3.367 1.949.822 4.053 1.06 6.873.46l-2.425 13.75c-.96 5.447-4.93 8.596-8.745 10.397a26.702 26.702 0 0 1-7.215 2.186h-.007a16.096 16.096 0 0 1-.4-.22 26.691 26.691 0 0 1-5.632-4.302c-2.97-2.997-5.623-7.314-4.663-12.76L12.584 9.77",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
